@if (isLoaded()) {
  <div class="hole-tolerance-container">
    <h3>{{ 'HOLE_TOLERANCE.TITLE' | translate }}</h3>

    <form #toleranceForm="ngForm" (ngSubmit)="save()">

      @for (t of formData.thresholds; track t.metric) {
        <app-tolerance-bar
          [label]="'HOLE_TOLERANCE.' + t.metric | translate"
          [unit]="t.unit"
          [asDesignedMax]="t.asDesignedMax"
          [inToleranceMax]="t.inToleranceMax"
          [asDesignedMin]="t.asDesignedMin ?? 0"
          [inToleranceMin]="t.inToleranceMin ?? 0"
          [showNegative]="t.asDesignedMin != null"
          [readOnly]="!editing()"
          [showError]="showError() && isRequired(t.metric) && !t.asDesignedMax"
          (asDesignedMaxChange)="t.asDesignedMax = $event; onValueChange()"
          (inToleranceMaxChange)="t.inToleranceMax = $event; onValueChange()"
          (asDesignedMinChange)="t.asDesignedMin = $event; onValueChange()"
          (inToleranceMinChange)="t.inToleranceMin = $event; onValueChange()"
        />
      }

      <div class="form-actions">
        @if (!editing()) {
          <button type="button" class="btn btn-modify" (click)="startEditing()" [disabled]="!formData.thresholds?.length">
            <i class="fa-solid fa-pen"></i>
            {{ 'GLOBAL.MODIFIER' | translate }}
          </button>
        } @else {
          <button type="button" class="btn btn-cancel" (click)="cancelEditing()">
            {{ 'GLOBAL.ANNULER' | translate }}
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="!hasChanges()">
            {{ 'GLOBAL.VALIDER' | translate }}
          </button>
        }
      </div>
    </form>
  </div>
}
